import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CloseButton, Modal, Spinner, Tab, Tabs } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import UploadFiles from 'components/common/UploadFiles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { readProductBook } from 'helpers/excel';
import { faCloudDownloadAlt, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
//import { contextProject } from 'context';
import TableTerrains from '../terrains/TableTerrains';
import TableFnc from '../financing/TableFnc';
import FormFnc from '../financing/FormFnc';
import FormTerrain from '../terrains/FormTerrain';
import Input from 'components/common/Input';
import IconButton from 'components/common/IconButton';

const NewProduct = ({ setValue, watch, register, errors }) => {
 //const { project, setProject } = contextProject();
 const [key, setKey] = useState('fnc');
 const [product, setProduct] = useState(null);
 const [financing, setFinancing] = useState(null);
 const [open, setOpen] = useState(false);
 const [data, setData] = useState([...(watch('products') || [])]);
 const [isLoading, setIsLoading] = useState(false);

 const onClose = () => setOpen(false);

 useEffect(() => {
  if (data.length) setValue('products', data);
 }, [data]);

 useEffect(() => {
  if (!watch()?.products?.length) setData([]);
 }, [watch()?.products]);

 useEffect(() => {
  if (financing || /\d/.test(product?.currentIndex)) {
   setKey(product ? 'prod' : 'fnc');
   setOpen(true);
  }
 }, [financing, product]);

 useEffect(() => {
  if (!open) {
   setFinancing(null);
   setProduct(null);
  }
 }, [open]);

 const handleDownload = () => {
  // URL del archivo que deseas descargar
  const fileUrl =
   'https://firebasestorage.googleapis.com/v0/b/inmovilii.appspot.com/o/fixed%2FProductCreation.xlsx?alt=media&token=83b69c8a-5663-435d-ac50-fe25d1495efa';

  // Crea un enlace (a) oculto para simular la descarga
  const link = document.createElement('a');
  link.href = fileUrl;
  link.setAttribute('download', '');

  // Añade el enlace al documento
  document.body.appendChild(link);

  // Dispara el clic en el enlace para iniciar la descarga
  link.click();

  // Elimina el enlace del documento
  document.body.removeChild(link);
 };

 return (
  <>
   <Card className="mb-3 bg-transparent border">
    <Card.Body className="fs--1">
     <Flex>
      <div className="flex-fill px-3 border-start border-start-400">
       <Flex className="cursor-pointer fs--1" onClick={handleDownload}>
        <span className="fa-stack me-2 ms-n1 circle-dashed cursor-pointer" style={{ width: '50px', height: '50px' }}>
         <FontAwesomeIcon icon="circle" className="fa-stack-2x fs-1 text-300" />
         <FontAwesomeIcon icon={faCloudDownloadAlt} className="fa-inverse fa-stack-1x fs-1 text-primary" ransform="shrink-3" />
        </span>
        <div className="flex-1 mt-1 d-none d-sm-block">
         <h5 className="mb-0 text-primary">
          <span className="pe-3">Bajar</span>
         </h5>
         <p className="mb-0">Excel.xlsx</p>
        </div>
       </Flex>
      </div>
      <div className="flex-fill px-3 border-start border-start-dark">
       <UploadFiles
        buffer={true}
        multiple={false}
        dropzoneArea={false}
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        isLoading={e => setIsLoading(e)}
        onChange={book => {
         const libro = readProductBook(['Products', 'Financings'], book);
         const Financings = libro.find(e => e.Financings)?.Financings;
         setData(libro.find(e => e.Products)?.Products);
         setValue(
          'financings',
          watch('financings')
           ?.filter(row => !Financings.some(e => e.name === row.name))
           .concat(Financings),
          {
           shouldValidate: true,
           shouldTouch: true
          }
         );
        }}
        placeholder={
         <Flex className="cursor-pointer fs--1">
          {isLoading ? (
           <Spinner animation="grow" role="status" className="fa-stack me-2 ms-n1" style={{ width: '50px', height: '50px' }}>
            <FontAwesomeIcon icon="circle" className="fa-stack-2x fs-1 text-300" />
            <FontAwesomeIcon icon={faCloudUploadAlt} className="fa-inverse fa-stack-1x fs-1 text-primary" ransform="shrink-3" />
           </Spinner>
          ) : (
           <span className="fa-stack me-2 ms-n1 circle-dashed cursor-pointer" style={{ width: '50px', height: '50px' }}>
            <FontAwesomeIcon icon="circle" className="fa-stack-2x fs-1 text-300" />
            <FontAwesomeIcon icon={faCloudUploadAlt} className="fa-inverse fa-stack-1x fs-1 text-primary" ransform="shrink-3" />
           </span>
          )}
          <div className="flex-1 mt-1 d-none d-sm-block">
           <h5 className="mb-0 text-primary">
            <span className="pe-3">Subir</span>
           </h5>
           <p className="mb-0">Excel.xlsx</p>
          </div>
         </Flex>
        }
       />
      </div>
     </Flex>
    </Card.Body>
   </Card>

   <Card className="mb-3">
    <Card.Header className="fs--1">
     <Flex wrap="wrap" alignContent="center" alignItems="center" justifyContent="end">
      <div className="mb-3 position-relative flex-grow-1">
       <h5 className="mb-0 text-primary">Financiamientos</h5>
       <p className="mb-0">estipule las características que podrían describir un proyecto por las ventajas que este ofrece</p>
       <span className="border position-absolute top-50 translate-middle-y w-100 start-0 z-index--1"></span>
      </div>
      <IconButton
       size="sm"
       variant="falcon-primary"
       className="float-end ms-3"
       icon="donate"
       iconAlign="right"
       transform="down-1 shrink-4"
       onClick={() => {
        setKey('fnc');
        setOpen(true);
       }}
      >
       Nuevo Fnc
      </IconButton>
     </Flex>
    </Card.Header>
    <Card.Body className="fs--1">
     {watch()?.financings?.length && <TableFnc data={{ ...watch() }} setData={setValue} setFinancing={setFinancing} />}

     <Input
      errors={errors}
      name="financings"
      type="hiddenInput"
      label="Error en financiacion!"
      formControlProps={{
       ...register('financings', { validate: value => value.length || 'Debe establecer al menos un financiamiento' })
       //defaultValue: project?.financings
      }}
     />
    </Card.Body>
   </Card>

   <Card className="mb-3">
    <Card.Header className="fs--1">
     <Flex wrap="wrap" alignContent="center" alignItems="center" justifyContent="end">
      <div className="mb-3 position-relative flex-grow-1">
       <h5 className="mb-0 text-primary">Productos</h5>
       <p className="mb-0">estipule las características que podrían describir un proyecto por las ventajas que este ofrece</p>
       <span className="border position-absolute top-50 translate-middle-y w-100 start-0 z-index--1"></span>
      </div>
      <IconButton
       size="sm"
       variant="falcon-primary"
       className="float-end ms-3"
       icon="donate"
       iconAlign="right"
       transform="down-1 shrink-4"
       onClick={() => {
        setKey('prod');
        setOpen(true);
       }}
      >
       Nuevo Prd
      </IconButton>
     </Flex>
    </Card.Header>
    <Card.Body className="fs--1">
     {watch()?.products?.length && <TableTerrains data={data} setData={setData} product={product} setProduct={setProduct} />}

     <Input
      name="products"
      errors={errors}
      type="hiddenInput"
      formControlProps={{
       ...register('products', { validate: value => value.length || 'Debe establecer al menos un lote' })
      }}
     />
     {/* errors.products && <Alerts message={errors.products.message} /> */}
    </Card.Body>
   </Card>

   <Modal show={open} onHide={onClose} className="mt-4 pb-4 pb-md-2">
    <Modal.Header className="bg-shape modal-shape-header px-4 position-relative">
     <div className="position-relative z-index-1 light">
      <h4 className="mb-0 text-white" id="authentication-modal-label">
       Gestion de productos
      </h4>
      <p className="fs--1 mb-0 text-white">Gestiona la creacion y edicion de una persona o empresa</p>
     </div>
     <CloseButton variant="white" className="position-absolute end-0 me-2 mt-2 top-0" onClick={onClose} />
    </Modal.Header>
    <Modal.Body className="p-4 pt-1">
     <Tabs id="controlled-tab-example" activeKey={key} onSelect={k => setKey(k)}>
      <Tab eventKey="fnc" title="Financiacion" className="pt-4">
       <FormFnc watch={watch} setData={setValue} financing={financing} setFinancing={setFinancing} onClose={onClose} />
      </Tab>
      <Tab eventKey="prod" title="Producto" className="pt-4">
       <FormTerrain
        data={[...(watch('financings') || [])]}
        setData={setData}
        product={product}
        setProduct={setProduct}
        onClose={onClose}
       />
      </Tab>
     </Tabs>
    </Modal.Body>
   </Modal>
  </>
 );
};

NewProduct.propTypes = {
 setValue: PropTypes.func.isRequired,
 watch: PropTypes.func.isRequired,
 register: PropTypes.func.isRequired,
 errors: PropTypes.object.isRequired,
 trigger: PropTypes.func.isRequired
};

//NewProduct.defaultProps = { files: [] };

export default NewProduct;
